import { Button, Checkbox, Form, Pagination, Spin, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import { ReactComponent as IconPDF } from "../../../assets/images/pdf.svg";
import { ReactComponent as IconUpDown } from "../../../assets/images/upDown.svg";
import PayoutProcessedRow from "./PayoutProcessedRow";
import "../PayoutInvoices/PayoutInvoices.scss";
import { downloadDocument, getEnumValue } from "shared/services/Utility";

interface IPayoutProcessed {
  payoutList: any;
  totalCount: number;
  handlePaginationChange: (pagination: any) => void;
}

const PayoutProcessed: React.FunctionComponent<IPayoutProcessed> = (
  props: IPayoutProcessed
) => {
  const { payoutList, totalCount, handlePaginationChange } = props;

  const payoutReq: any = useSelector((state: RootState) => state.payoutReq);
  const { appColors }: any = useSelector((state: RootState) => state.common);
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);
  const [formPayout] = Form.useForm();

  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);

  const columns: any = [
    {
      title: "Invoice ID",
      dataIndex: "invoiceId",
      key: "invoiceId",
    },
    {
      title: "Invoice No.",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      width: 140,
      showTooltip: true,
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
    },
    {
      title: "IRN",
      dataIndex: "irn",
      key: "irn",
    },
    {
      title: "Connector Business Name",
      dataIndex: "connectorBusinessName",
      key: "ConnectorBusinessName",
      width: 150,
      showTooltip: true,
    },
    {
      title: "Connector Name",
      dataIndex: "connectorName",
      key: "ConnectorName",
      width: 150,
      showTooltip: true,
    },
    {
      title: "Invoice Amount",
      dataIndex: "invoiceAmount",
      key: "invoiceAmount",
      isAmount: true,
    },
    {
      title: "TDS",
      dataIndex: "tds",
      key: "TDS",
      isAmount: true,
    },
    {
      title: "Net Payable Amount",
      dataIndex: "netPayableAmount",
      key: "netPayableAmount",
      isAmount: true,
    },
    {
      title: "Invoice Upload Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
    },
    {
      title: "Total Paid Amount",
      dataIndex: "totalPaidAmount",
      key: "totalPaidAmount",
      isAmount: true,
    },
    {
      title: "Balance Amount",
      dataIndex: "balanceAmount",
      key: "balanceAmount",
      isAmount: true,
    },
    {
      title: "Status",
      dataIndex: "invoiceStage",
      key: "invoiceStage",
      render: (record: any) =>
        getEnumValue("INVOICE_STAGE", record?.invoiceStage),
    },
    {
      title: "Signed Invoice",
      dataIndex: "SignedInvoice",
      key: "SignedInvoice",
      className: "h-center",
      fixed: "right",
      render: (record: any) => {
        return (
          <Button
            className="custome-btn-icon-play"
            style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
            size="small"
            type="text"
            hidden={!record?.latestSignedDocumentId}
            onClick={() =>
              downloadDocument({
                businessDocumentId: record?.latestSignedDocumentId,
              })
            }
            icon={<IconPDF />}
          />
        );
      },
    },
    {
      title: "Payment Details",
      dataIndex: "PaymentDetails",
      key: "PaymentDetails",
      className: "h-center",
      fixed: "right",
      render: (record) => {
        return (
          <Button
            className="custome-btn-icon-play"
            style={{ "--bgColor": appColors?.appPrimaryColor ?? "" } as any}
            size="small"
            type="text"
            onClick={() => {
              if (selectedInvoices.includes(record?.invoiceId)) {
                setSelectedInvoices(
                  selectedInvoices?.filter(
                    (item: any) => item != record?.invoiceId
                  )
                );
              } else {
                setSelectedInvoices([...selectedInvoices, record?.invoiceId]);
              }
            }}
            icon={<IconUpDown />}
          />
        );
      },
    },
  ];

  return (
    <>
      <div className="payout-invoices-main">
        <div className="payout-invoices-table-header">
          {columns?.map((data: any, index: number) => {
            let styleExtra: any = {};
            if (data?.fixed == "right") {
              let right = 0;
              if (columns.length - 1 != index) {
                for (let i = index + 1; i < columns.length; i++) {
                  right = right + (columns.at(i)?.width ?? 120);
                }
              }
              let sty = {};
              if (columns.at(index - 1)?.fixed !== "right") {
                sty = { borderLeft: "1px solid #DFE0EB" };
              }
              styleExtra = {
                position: "sticky",
                right: right,
                zIndex: 10,
                ...sty,
              };
            }
            return (
              <div
                style={{
                  flex: "none",
                  width: data?.width ?? "120px",
                  ...styleExtra,
                }}
                className={data?.className ?? ""}
              >
                {data.title}
              </div>
            );
          })}
        </div>
        {(payoutList?.length ?? 0) == 0 ? (
          <div style={{ height: "100px" }} />
        ) : (
          payoutList?.map((payout: any) => {
            return (
              <PayoutProcessedRow
                formPayout={formPayout}
                payout={payout}
                columns={columns}
                selectedInvoices={selectedInvoices}
                setSelectedInvoices={setSelectedInvoices}
              />
            );
          })
        )}
      </div>
      <div className="payout-invoices-footer">
        <div>
          {tenantInfo.connectorInvoicingEnabled ? "" : "Invoicing is disabled"}
        </div>
        <Pagination
          current={payoutReq.pageNo}
          pageSize={payoutReq.pageSize}
          total={totalCount}
          onChange={(page: number, pageSize: number) => {
            handlePaginationChange({ pageSize, current: page });
          }}
        />
      </div>
    </>
  );
};

export default PayoutProcessed;
